<template>
  <div
    class="container"
    v-if="stepPrizeShow"
    :style="{ background: `url(${dakaInfo.activityReceivePicture}) no-repeat`, backgroundSize: 'cover'  }"
  >
    <!-- <div class="user_img"></div> -->
    <img class="user_img" :src="userInfo.avatar || userHeader" alt />
    <div class="box">
      <div class="title">
        已坚持打卡:
        <span>{{dakaInfo.continuousMaxDakaNumber}}</span> 天
      </div>

      <div class="step_box">
        <div class="step_item_zw"></div>
        <div class="step_item">
          <div class="right">
            <img
              class="img"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/step_prize_icon.png"
              alt
            />
            <div class="txt">开始</div>
          </div>
        </div>

        <div class="step_item" v-for="(item, index) in renderList" :key="item.activityPrizeId">
          <div
            :class="['left', item.number <= dakaInfo.continuousMaxDakaNumber ? 'left_active' : '']"
          ></div>
          <div class="right" v-if="index !== renderList.length -1">
            <img
              class="img"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/step_prize_icon.png"
              alt
              v-if="item.number <= dakaInfo.continuousMaxDakaNumber"
            />
            <img
              class="img"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/step_prize_icon2.png"
              alt
              v-else
            />
            <div class="txt">{{item.number}}天</div>
          </div>
          <div class="right right2" v-else>
            <img
              class="img_end"
              src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/step_prize_icon3.png"
              alt
            />
            <div class="txt">{{item.number}}天</div>
          </div>
        </div>
      </div>

      <div class="prize_box">
        <div class="prize_star">{{stepCacheInfo.number}}天奖励</div>
        <div class="prize_img">
          <img :src="stepCacheInfo.prizePicture" alt />
        </div>
        <img
          class="prize_btn"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/step_prize_btn.png"
          alt
          @click="onStepPrizeClose"
        />
      </div>
    </div>
  </div>
</template>

<script>
import userHeader from '@/assets/img/loginImg/userHeader.png';

export default {
  props: {
    dakaInfo: {
      type: Object,
      default: () => {},
    },
    stepCacheInfo: {
      type: Object,
      default: () => {},
    },
    currPrizeIndex: {
      type: Number,
      default: 0,
    },
    stepPrizeShow: {
      type: Boolean,
      default: false,
    },
    userInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      renderList: [],
      currNumber: 0,
      currImg: '',
      userHeader,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { dakaActivityPrizeDataList } = this.dakaInfo;
      const rawRenderList = [];
      dakaActivityPrizeDataList.forEach((item, index) => {
        const { number, activityPrizeId, prizePicture } = item;
        // if (index === this.currPrizeIndex) {
        //   this.currNumber = number;
        //   this.currImg = prizePicture;
        // }
        rawRenderList.push({
          activityPrizeId,
          number,
          // isReceive: index <= this.currPrizeIndex,
        });
      });
      this.renderList = rawRenderList;
    },
    onStepPrizeClose() {
      this.$emit('onStepPrizeClose');
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  position: fixed;
  z-index: 19;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/step_prize_bkg.png')
    no-repeat;
  background-size: cover;

  .user_img {
    position: absolute;
    z-index: 3;
    width: 181px;
    height: 181px;
    top: 145px;
    left: 284px;
    border: 4px solid #ffffff;
    border-radius: 50%;
    overflow: hidden;
    img {
      display: block;
      height: 100%;
      width: 100%;
    }
  }

  .box {
    position: absolute;
    z-index: 1;
    width: 678px;
    height: 980px;
    background: #ffffff;
    border-radius: 36px;
    top: 236px;
    left: 36px;

    .title {
      height: 76px;
      line-height: 76px;
      font-weight: 500;
      font-size: 36px;
      color: #333333;
      margin: 132px auto 0;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 11px;

      span {
        height: 76px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 54px;
        color: #ff7f41;
        line-height: 70px;
      }
    }

    .step_box {
      display: flex;
      justify-content: center;
      width: 552px;
      padding: 20px 10px 0;
      overflow-x: auto;
      margin: 0 auto 0;

      .step_item_zw{
        height: 1px;
        width: 25px;
        flex-shrink: 0;
      }

      .step_item {
        display: flex;
        flex-shrink: 0;
        .left {
          width: 134px;
          height: 11px;
          background: #dfe6ff;
          border-radius: 13px;
          margin-top: 15px;
        }

        .left_active {
          background: #ff5472;
        }

        .right {
          display: flex;
          flex-direction: column;
          align-items: center;
          .img {
            display: block;
            height: 40px;
            width: 40px;
          }

          .img_end {
            display: block;
            height: 54px;
            width: 54px;
            margin-top: -14px;
          }

          .txt {
            height: 36px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 25px;
            color: #999999;
            line-height: 36px;
            margin-top: 18px;
            text-align: center;
            // width: 40px;
            white-space: nowrap;
          }
        }

        .right2 {
          margin-left: -13px;
        }
      }
    }
    .step_box {
      overflow-x: auto;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
    }

    .step_box::-webkit-scrollbar {
      display: none; /* Chrome, Safari and Opera */
    }

    .prize_box {
      height: 556px;
      width: 489px;
      margin: 48px auto 0;
      background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/step_prize_img.png')
        no-repeat;
      background-size: cover;
      overflow: hidden;

      .prize_star {
        height: 22px;
        width: 341px;
        margin: 49px auto 0;
        background: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/check/step_prize_star.png')
          no-repeat;
        background-size: cover;
        font-weight: 600;
        font-size: 33px;
        color: #ff3938;
        text-align: center;
        line-height: 19px;
      }

      .prize_img {
        width: 254px;
        height: 254px;
        background: #ffeef1;
        border-radius: 29px;
        border: 2px solid #fd3665;
        margin: 40px auto 0;
        overflow: hidden;
        img {
          width: 254px;
          height: 254px;
        }
      }

      .prize_btn {
        display: block;
        height: 91px;
        width: 326px;
        margin: 51px auto 0;
      }
    }
  }
}
</style>